import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { ShortCard } from "@/components/ShortCard";
import { api } from "@/lib/api";

export default function BanglaTok() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get("/banglatok", { params: { limit: 30 } })
      .then(({ data }) => { if (active) setItems(data.items || []); })
      .catch(() => { if (active) setItems([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <>
      <Header />
      <div className="px-4 pt-2 pb-3">
        <h1 className="font-heading text-3xl font-bold flex items-center gap-2">
          BanglaTok <span className="text-brand">•</span>
        </h1>
        <p className="text-white/55 text-sm">Bite-sized Bangla shorts. Tap any tile to watch.</p>
      </div>
      {loading ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 px-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="aspect-[9/16] rounded-xl bg-bg-surface animate-pulse" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <p className="text-white/40 text-sm text-center py-16">No shorts yet.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 px-4" data-testid="banglatok-grid">
          {items.map((v) => <ShortCard key={v.video_id} video={v} />)}
        </div>
      )}
    </>
  );
}
